export const QUERY_KEYS = {
  APP_STICKY_RIBBONS_LIST: "APP_STICKY_RIBBONS_LIST",
};

export const STICKY_RIBBON_KIND_TO_STYLE = {
  info: "info",
  warning: "warning",
  error: "danger",
};

export const STICKY_RIBBONS_LOCAL_STORAGE_KEY = "dismissedStickyRibbons";

export const POLLING_INTERVAL = 5000;
export const MAX_POLLING_TIME = 60000;

export const DATE_TIME_FORMAT = "MMMM D h:mm A z";
